import * as api from "services/api";
import { getErrors } from "helpers/error";

export const CREATE_OBLIGATION = "[OBLIGATION CREATE] CREATE_OBLIGATION";
export const CREATE_OBLIGATION_ERROR =
	"[OBLIGATION CREATE] CREATE_OBLIGATION_ERROR";
export const CREATE_OBLIGATION_SUCCESS =
	"[OBLIGATION CREATE] CREATE_OBLIGATION_SUCCESS";

export const SET_VALUE = "[OBLIGATION CREATE] SET_VALUE";
export const CLEAR_VALUES = "[OBLIGATION CREATE] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function createObligation(model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: CREATE_OBLIGATION
		});

		try {
			const { login } = getState();

			let response = await api.sendPost("/obligation", model, {
				Authorization: "Bearer " + login.token
			});

			let result = await response.json();
			if (response.ok) {
				dispatch({
					type: CREATE_OBLIGATION_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: CREATE_OBLIGATION_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: CREATE_OBLIGATION_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
